<template>
  <div>
    <div class="container-fluid" style="zoom: 80%">
      <div class="row">
        <div class="col-md-12 mb-2">
          <h3 style="font-weight:700">Account Settings</h3>
        </div>
        <Sidebar />
        <div class="col-md-10 pl-0">
          <div
            class="card card-box mb-3 "
            style="border-radius : 0%; height: 97.5%;"
          >
            <div class="card-body">
              <b-form>
                <div class="row">
                  <div class="col-md-12 mt-2 mb-3">
                    <h4 class="__blue" style="font-weight: 700">
                      Lokasi
                    </h4>
                  </div>
                </div>
                <div class="row mb-4" v-if="satusehatAuthValid">
                  <div class="col-md">
                    <div class="sync-info py-3 px-3">
                      <div>
                        <font-awesome-layers style="font-size: 27px;">
                          <font-awesome-icon
                            :icon="['far', 'circle']"
                            style="opacity: 0.3;color: #3772d7"
                          />
                          <font-awesome-icon
                            :icon="['fas', 'info']"
                            transform="shrink-8"
                            style="color: #3772d7"
                          />
                        </font-awesome-layers>
                      </div>
                      <div class="ml-2 my-auto">
                        <font-awesome-layers style="font-size: 27px;">
                          <font-awesome-icon
                            :icon="['far', 'circle']"
                            style="opacity: 0.3;"
                          />
                          <font-awesome-icon
                            :icon="['fas', 'sync']"
                            transform="shrink-8"
                            style="color: #3772d7"
                          />
                        </font-awesome-layers>
                      </div>
                      <div class="ml-2" style="margin-top: 3px;">
                        Tekan button di samping untuk melakukan Sync dengan
                        SatuSehat.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="!locationArr.length">
                  <div class="col-md">
                    <div class="text-center" style="opacity: 0.7;">
                      Silakan tambahkan ruangan/lokasi tiap poliklinik di Klinik
                      Anda
                    </div>
                  </div>
                </div>
                <div class="row list-location" v-else>
                  <div
                    class="col-md-6 mb-4"
                    v-for="(location, index) in locationArr"
                    :key="index"
                  >
                    <div class="d-flex">
                      <b-input-group
                        :id="`id_locationInput${index}`"
                        @mouseover="checkTextOverflow(index)"
                        @mouseleave="handleMouseLeave(index)"
                      >
                        <template
                          #append
                          v-if="!btnDisable && locationArr[index].state == null"
                        >
                          <b-input-group-text
                            :class="btnDisable ? 'disabled' : ''"
                            @click="!btnDisable ? deleteField(index) : true"
                          >
                            <!-- <font-awesome-icon icon="xmark" /> -->
                            <font-awesome-icon
                              :icon="['fas', 'times']"
                              style="color: #da0b0b;"
                            />
                          </b-input-group-text>
                        </template>
                        <b-form-input
                          @input="onInputLocation(index)"
                          :disabled="btnDisable"
                          v-model="locationArr[index].name"
                          :ref="'locationInput' + index"
                          :class="{
                            'border-right-none':
                              !btnDisable && locationArr[index].state == null
                          }"
                          style="text-overflow: ellipsis;"
                          :state="locationArr[index].state"
                        ></b-form-input>
                        <b-form-invalid-feedback
                          >Wajib diisi</b-form-invalid-feedback
                        >
                        <b-popover
                          :container="`id_locationInput${index}`"
                          :target="`id_locationInput${index}`"
                          :ref="`ref_popover_${index}`"
                          placement="top"
                          v-if="btnDisable"
                        >
                          {{ locationArr[index].name }}
                        </b-popover>
                      </b-input-group>
                      <span
                        class="ml-2 d-flex align-items-center"
                        v-if="btnDisable && satusehatAuthValid"
                      >
                        <font-awesome-icon
                          v-if="locationArr[index].synced"
                          :icon="['fas', 'check-circle']"
                          style="color: #1ad52f; font-size: 27px;"
                        />
                        <font-awesome-layers v-else style="font-size: 27px;">
                          <font-awesome-icon
                            :icon="['far', 'circle']"
                            style="opacity: 0.3;"
                          />
                          <font-awesome-icon
                            :icon="['fas', 'sync']"
                            transform="shrink-8"
                            style="color: #3772d7;cursor:default;"
                            spin
                            v-if="locationArr[index].syncing"
                          />
                          <font-awesome-icon
                            v-else
                            @click="syncHandler(index)"
                            :icon="['fas', 'sync']"
                            transform="shrink-8"
                            style="color: #3772d7;cursor: pointer;"
                          />
                        </font-awesome-layers>
                      </span>
                    </div>
                  </div>
                </div>
              </b-form>
            </div>
            <div class="card-footer">
              <div class="row">
                <div class="col-md text-right">
                  <b-button
                    @click="simpanHandler"
                    variant="primary"
                    v-if="!btnDisable"
                    >Simpan</b-button
                  >
                  <b-button
                    variant="primary"
                    v-if="btnDisable"
                    :disabled="locationArr.length == 0"
                    @click="btnDisable = false"
                    >Edit</b-button
                  >
                  <b-button
                    v-b-modal.modal-add-location
                    class="ml-4"
                    variant="success"
                    v-if="btnDisable"
                    >Tambah</b-button
                  >
                  <b-button
                    class="ml-4"
                    variant="danger"
                    v-if="!btnDisable"
                    @click="
                      btnDisable = !btnDisable;
                      fetchData();
                    "
                    >Tutup</b-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      ref="ref-modal-add-location"
      centered
      id="modal-add-location"
      header-class="custom-header"
      hide-footer
      @hidden="resetForm"
    >
      <b-container fluid>
        <div class="row">
          <div class="col-md">
            <p class="font-weight-600">Tambah Lokasi Unit</p>
          </div>
        </div>
        <b-form @submit.stop.prevent="onSubmit" v-if="show">
          <div class="row">
            <div class="col-md">
              <b-form-group>
                <b-form-input
                  id="input-2"
                  v-model="$v.form.locationName.$model"
                  placeholder="Nama"
                  :state="validateState('locationName')"
                  aria-describedby="input-1-live-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="input-1-live-feedback"
                  >Wajib diisi</b-form-invalid-feedback
                >
              </b-form-group>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md text-right">
              <b-button @click="resetForm()" variant="danger" class="mr-3"
                >Batal</b-button
              >
              <b-button
                type="submit"
                variant="success"
                :disabled="
                  form.locationName === null || form.locationName === ''
                "
                >Tambah</b-button
              >
            </div>
          </div>
        </b-form>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faSync,
  faCheckCircle,
  faInfoCircle,
  faInfo
} from "@fortawesome/free-solid-svg-icons";
import { faCircle as farCircle } from "@fortawesome/free-regular-svg-icons";

library.add(faSync, farCircle, faCheckCircle, faInfoCircle, faInfo);

export default {
  mixins: [validationMixin],
  components: {
    Sidebar: () => import("@/views/AccountSettingKlinik/Sidebar")
  },
  data: () => {
    return {
      btnDisable: true,
      show: true,
      status: true,
      btnDisable: true,
      form: {
        locationName: null
      },
      locationArr: []
    };
  },
  mounted() {
    this.fetchData();
    window.scrollTo({
      top: 95,
      behavior: "smooth"
    });
  },
  computed: {
    ...mapGetters(["getKlinikId", "satusehatAuthValid"])
  },
  validations: {
    form: {
      locationName: {
        required
      }
    }
  },
  methods: {
    onInputLocation(index) {
      // console.log(index);
      if (this.locationArr[index].name == "") {
        this.locationArr[index].state = false;
      } else {
        this.locationArr[index].state = null;
      }
    },
    syncHandler(index) {
      if (!this.locationArr[index].syncing) {
        this.locationArr[index].syncing = true;
        this.syncLocationSatusehat(index);
      }
    },
    async syncLocationSatusehat(index) {
      try {
        const res = await this.$axios.post(
          `satu-sehat/location/sync`,
          {
            lokasi_id: this.locationArr[index].id,
            klinik_id: this.getKlinikId,
            lokasi: this.locationArr[index].name,
            satusehat_location_id: this.locationArr[index].satusehat_location_id
          }
        );

        // console.log(res.data.status);

        if (!res.data.status) {
          this.$swal({
            text: `Gagal melakukan Sync dengan Satu Sehat`,
            type: "error"
          });
          this.locationArr[index].syncing = false;
          return;
        }

        this.locationArr[index].synced = true;
        this.locationArr[index].satusehat_location_id =
          res.data.data.satusehat_location_id;
      } catch (error) {
        this.locationArr[index] = false;
        this.$swal({
          text: `Gagal melakukan Sync dengan Satu Sehat`,
          type: "error"
        });
      }
    },
    handleMouseLeave(index) {
      this.$refs[`ref_popover_${index}`][0].$emit("close");
    },
    checkTextOverflow(index) {
      const inputElement = this.$refs[`locationInput${index}`][0];

      if (inputElement.$el.scrollWidth > inputElement.$el.clientWidth + 1) {
        this.$refs[`ref_popover_${index}`][0].$emit("open");
      }
    },
    deleteField(index) {
      this.locationArr.splice(index, 1);
    },
    findLastDuplicateIndexes(arr) {
      arr = arr.map(item => item.name);
      const lastIndexMap = {};
      for (let i = arr.length - 1; i >= 0; i--) {
        const currentElement = arr[i];
        if (lastIndexMap[currentElement] !== undefined) {
          return lastIndexMap[currentElement];
        }
        lastIndexMap[currentElement] = i;
      }
      return -1;
    },
    focusInput(index) {
      const inputRef = this.$refs["locationInput" + index][0];
      inputRef.focus();
    },
    hasDuplicates(array) {
      array = array.map(item => item.name);
      let uniqueElements = new Set();
      for (let element of array) {
        if (uniqueElements.has(element)) {
          return true;
        }
        uniqueElements.add(element);
      }
      return false;
    },
    simpanHandler() {
      let formError = false;
      this.locationArr.forEach((element, index) => {
        if (element.state === false) {
          formError = true;
        }
      });
      if (formError) {
        return;
      }
      if (this.hasDuplicates(this.locationArr)) {
        this.focusInput(this.findLastDuplicateIndexes(this.locationArr));
        this.$swal({
          type: "warning",
          html:
            '<p class="m-0 text-bridging-bpjs">Nama Ruangan/Lokasi Sudah Ada.</p>',
          customClass: {
            confirmButton: "btn btn-success"
          },
          buttonsStyling: false
        });
        return;
      }
      this.hitEditLocation();
      // console.log(JSON.stringify(this.locationArr));
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    hideModal() {
      this.$refs["ref-modal-add-location"].hide();
    },
    resetForm() {
      this.form = {
        locationName: null
      };

      this.show = false;
      this.$nextTick(() => {
        this.show = true;
        this.$v.$reset();
      });
      this.hideModal();
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const locationArrName = this.locationArr.map(item => item.name);
      if (locationArrName.includes(this.form.locationName)) {
        this.$swal({
          type: "warning",
          html:
            '<p class="m-0 text-bridging-bpjs">Nama Ruangan/Lokasi Sudah Ada.</p>',
          customClass: {
            confirmButton: "btn btn-success"
          },
          buttonsStyling: false
        });
        return;
      }

      this.hitAddLocation();

      // console.log(JSON.stringify(this.locationArr));
    },
    async hitAddLocation() {
      try {
        const res = await this.$axios.post(
          `satu-sehat/location?klinik_id=${this.getKlinikId}`,
          this.form
        );
        const { status, data } = res.data;

        if (status) {
          // this.locationArr.push({ id: data.id, name: data.name });
          this.resetForm();
          this.$swal({
            type: "success",
            html:
              '<p class="m-0 text-bridging-bpjs">Lokasi Unit Berhasil Disimpan</p>',
            customClass: {
              confirmButton: "btn btn-success"
            },
            buttonsStyling: false
          });
          this.fetchData();
        } else {
          this.$swal({
            type: "warning",
            html:
              '<p class="m-0 text-bridging-bpjs">Lokasi gagal ditambahkan!</p>',
            customClass: {
              confirmButton: "btn btn-success"
            },
            buttonsStyling: false
          });
        }
      } catch (error) {
        this.$swal({
          type: "warning",
          html: '<p class="m-0 text-bridging-bpjs">Terjadi Kesalahan</p>',
          customClass: {
            confirmButton: "btn btn-success"
          },
          buttonsStyling: false
        });
      }
    },
    async hitEditLocation() {
      try {
        const res = await this.$axios.put(
          `satu-sehat/location?klinik_id=${this.getKlinikId}`,
          { location: this.locationArr }
        );
        const { status } = res.data;

        if (status) {
          this.$swal({
            type: "success",
            html:
              '<p class="m-0 text-bridging-bpjs">Lokasi Unit Berhasil Disimpan</p>',
            customClass: {
              confirmButton: "btn btn-success"
            },
            allowOutsideClick: false,
            buttonsStyling: false
          });
        } else {
          this.$swal({
            type: "warning",
            html: '<p class="m-0 text-bridging-bpjs">Gagal Edit!</p>',
            customClass: {
              confirmButton: "btn btn-success"
            },
            buttonsStyling: false
          });
        }
        this.fetchData();
        this.btnDisable = true;
      } catch (error) {
        this.$swal({
          type: "warning",
          html: '<p class="m-0 text-bridging-bpjs">Terjadi Kesalahan</p>',
          customClass: {
            confirmButton: "btn btn-success"
          },
          buttonsStyling: false
        });
        this.fetchData();
      }
      this.btnDisable = true;
    },
    async fetchData() {
      try {
        const res = await this.$axios.get(
          `satu-sehat/location/${this.getKlinikId}`
        );
        const { status, data } = res.data;

        if (status) {
          if (data.length) {
            this.locationArr = data.map(item => {
              return {
                id: item.id,
                name: item.name,
                synced: item.synced_to_satusehat,
                satusehat_location_id: item.satusehat_location_id,
                syncing: false,
                state: null
              };
            });
          }
          this.status = true;
        }
      } catch (e) {
        // console.log(e);
      }
    }
  }
};
</script>

<style>
.col-form-label {
  margin-bottom: 20px;
}
.text-bridging-bpjs {
  font-size: 14px;
  font-weight: 600;
}
.modal_loading .modal-header {
  background-color: #ffffff;
}
.modal-backdrop {
  opacity: 0.5 !important;
}

#modal-add-location___BV_modal_header_ {
  border-bottom: none;
  padding-bottom: 0px;
}

#modal-add-location___BV_modal_footer_ {
  border-top: none;
  padding-top: 0px;
}
</style>

<style scoped>
.sync-info {
  border-style: solid;
  border-width: 1px;
  border-color: #b1c7dc;
  border-radius: 8px;
  display: inline-flex;
  background-color: #e5eff9;
}

.__blue {
  color: #4b80b6;
}
.alert {
  border-radius: 5px;
}
.alert-radio-label {
  padding: 0.75rem 2rem;
  margin-right: 50px;
}
.alert-bridging-bpjs {
  background-color: #eeeff8;
  opacity: 1;
  top: -10px;
}
.p-bridging-bpjs {
  margin: 0;
}
.spinner-border {
  width: 5em;
  height: 5em;
}

.input-group-text {
  background-color: transparent;
}

.input-group-text.disabled {
  background-color: #eeeff8;
}

.opacity-70 {
  opacity: 70%;
}

.card-footer {
  border-top: none;
}

.font-weight-600 {
  font-weight: 600;
}
.list-location .input-group-append {
  cursor: pointer;
  border-left: none;
}

.list-location .input-group-append .input-group-text {
  border-left: none;
}

.border-right-none {
  border-right: none;
}

.list-location .input-group-append .input-group-text.active {
  color: #3b3e66;
  background-color: #fff;
  border-color: #9297da;
  outline: 0;
  box-shadow: 0 0.313rem 0.719rem rgba(122, 123, 151, 0.1),
    0 0.156rem 0.125rem rgba(122, 123, 151, 0.06);
}
</style>
